module.exports = __webpack_public_path__ + "img/hmong.a4e3b886.svg";